"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var TableActionConfirm_1 = require("../../../../../../shared/components/table_actions/TableActionConfirm");
var TableActionLockLock_1 = require("../../../../../../shared/components/table_actions/TableActionLockLock");
var TableActionReject_1 = require("../../../../../../shared/components/table_actions/TableActionReject");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var FinanceRevsharesList = /** @class */ (function (_super) {
    __extends(FinanceRevsharesList, _super);
    function FinanceRevsharesList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Бренд',
                dataIndex: _this.props.data.dk_brand_title,
                key: _this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Партнер',
                dataIndex: _this.props.data.dk_partner_login,
                key: _this.props.data.dk_partner_login,
                width: 200,
            }, {
                title: 'Оффер',
                dataIndex: _this.props.data.dk_brand_offer_title,
                key: _this.props.data.dk_brand_offer_title,
                width: 150,
            }, {
                title: 'П.Программа',
                dataIndex: _this.props.data.dk_pprogram_title,
                key: _this.props.data.dk_pprogram_title,
                width: 200,
            }, {
                title: 'Тип транзакции',
                dataIndex: _this.props.data.dk_revshare_type_title,
                key: _this.props.data.dk_revshare_type_title,
                width: 250,
            }, {
                title: 'Кассир',
                dataIndex: _this.props.data.dk_admin_cashier_login,
                key: _this.props.data.dk_admin_cashier_login,
                width: 150,
            }, {
                title: 'Сумма',
                dataIndex: _this.props.data.dk_amount,
                key: _this.props.data.dk_amount,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.formatCurrency(record.amount)));
                }
            }, {
                title: 'Валюта',
                dataIndex: _this.props.data.dk_partner_currency_title,
                key: _this.props.data.dk_partner_currency_title,
                width: 150,
            }, {
                title: 'Статус',
                dataIndex: _this.props.data.dk_flow_state_title,
                key: _this.props.data.dk_flow_state_title,
                width: 150,
            }, {
                title: 'Дата',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null, _this.getActionButtons(record))); },
                width: 110
            }
        ];
        return _this;
    }
    FinanceRevsharesList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    FinanceRevsharesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FinanceRevsharesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceRevsharesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    FinanceRevsharesList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadRangeDataByBrandsList({
            pprograms: this.props.PProgramsList,
            allPPrograms: this.props.allPPrograms,
            Limit: this.state.pageSize,
            Offset: this.getDataOffset(),
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    FinanceRevsharesList.prototype.onConfirmClick = function (record) {
        this.props.data.DoConfirmRevshare(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ",
                React.createElement("b", null,
                    "[",
                    record.key,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u0430 \u043D\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435"));
        });
    };
    FinanceRevsharesList.prototype.onRejectClick = function (record) {
        this.props.data.DoRejectRevshare(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ",
                React.createElement("b", null,
                    "[",
                    record.key,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"));
        });
    };
    FinanceRevsharesList.prototype.getActionButtons = function (record) {
        var _this = this;
        var _ret = [];
        if (record.is_pending) {
            _ret.push(React.createElement(TableActionConfirm_1.default, { hint: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C", confirmText: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { _this.onConfirmClick(record); }, key: "ab_1" }));
            _ret.push(React.createElement(TableActionReject_1.default, { hint: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C", confirmText: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { _this.onRejectClick(record); }, key: "ab_2" }));
        }
        else {
            _ret.push(React.createElement(TableActionLockLock_1.default, { disabled: true, confirmText: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { }, key: "al_1" }));
            _ret.push(React.createElement(TableActionLockLock_1.default, { disabled: true, confirmText: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { }, key: "al_2" }));
        }
        return _ret;
    };
    FinanceRevsharesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props);
        });
    };
    FinanceRevsharesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action == "create") {
            if (this.props.onNewrevShare) {
                this.props.onNewrevShare();
            }
        }
    };
    FinanceRevsharesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    FinanceRevsharesList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    FinanceRevsharesList.prototype.doCalculateRevShares = function () {
        var _this = this;
        var _dtFrom = moment().startOf('month');
        var _dtTo = moment().add(0, 'd').set('hour', 0).set('minute', 0).set('second', 0);
        //
        this.props.dlgCalculateRevShare
            .SetDateFrom(_dtFrom)
            .SetDateTo(_dtTo)
            .SetTitle("Расчет revshare")
            .SetOnYesClick(function (dFrom, dTo, ignoreStart) {
            _this.props.data.DoGenerateRevshare({
                pprograms: _this.props.PProgramsList,
                allPPrograms: _this.props.allPPrograms,
                from_year: dFrom.get('year'),
                from_month: dFrom.get('month') + 1,
                from_day: dFrom.get('date'),
                to_year: dTo.get('year'),
                to_month: dTo.get('month') + 1,
                to_day: dTo.get('date'),
                is_ignore_start_date: ignoreStart
            }, function (generatedCount) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0420\u0430\u0441\u0447\u0435\u0442 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0439 \u043E\u043A\u043E\u043D\u0447\u0435\u043D! \u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E [",
                    generatedCount,
                    "] \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0439"));
                if (generatedCount > 0) {
                    _this.loadData(_this.props);
                }
            });
        })
            .Show();
    };
    FinanceRevsharesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Создать" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allPPrograms, availBrands: this.props.availPPrograms, captions: { checkbox: "Все П.Программы", placeholder: "Выберите П.Программу" }, selectedBrands: this.props.PProgramsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E:"),
                            " [",
                            record.balance_before,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435:"),
                            " [",
                            record.balance_after,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                            " [",
                            record.description,
                            "]")));
                }, scroll: { x: true } })));
    };
    return FinanceRevsharesList;
}(React.Component));
exports.default = FinanceRevsharesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_revshares_list/ui/component/FinanceRevsharesList.tsx
// module id = 2454
// module chunks = 0